import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
      <p className="text-gray-600">Loading...</p>
    </div>
  </div>
);

const RedirectingMessage = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-pulse">
        <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-500 rounded-full mx-auto mb-4 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>
      </div>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        Redirecting to login...
      </h2>
      <p className="text-gray-600">
        Please wait while we redirect you to the login page.
      </p>
    </div>
  </div>
);

const ProtectedRoute = ({ component: Component, ...args }) => {
  const WrappedComponent = withAuthenticationRequired(Component, {
    onRedirecting: () => <RedirectingMessage />,
    ...args,
  });

  return <WrappedComponent />;
};

export default ProtectedRoute;
export { LoadingSpinner };
